<template>
   <main v-show="startRender">
    <div class="myPost_wrapper" id="more_board">
      <!-- title -->
      <div class="main_top">
        <h1><img src ="images/basic/icon/back.svg" onclick="history.back()" class="back">
          도움말
        </h1>
        <a class="h1_div" href="https://pf.kakao.com/_Txcabs/chat">
          <img onclick="location.href = 'https://pf.kakao.com/_Txcabs/chat';" src="images/basic/icon/more-qna.svg" alt="">
        </a>
      </div>
      <div class="div_padding"></div>

      <!-- list -->
        <div class="ul_menu_div">
          <ul class="menu_ul">
            <li v-for="category in categoryList" :key="category.ordr" :class="category.category == type ? 'active' : ''" @click="selectCategory(category.category)">{{ category.categoryNm }}</li>
          </ul>
        </div>
        <div class="post_list list_div" id="help1">
          <div class="post" v-for="(faq) in faqList" :key="faq.nttId">
            <div class="text_help">
              <div class="q" @click="toggleAnswer($event)" >
                  {{ faq.nttSj }}
              </div>
              <div class="a" v-html="faq.nttCn">
              </div>
            </div>
          </div>
        </div>
    </div>

  </main>
</template>

<script>
import { fetchFAQList, fetchFAQCategoryList } from '@/api/notice'
export default {
  mounted() {
    var offset = 50;
    window.addEventListener('scroll', () => { // scroll event 등록 
      if(window.$(window).scrollTop() > (window.$(document).height() - window.$(window).height()) - offset){
          this.fetchData();
      }
    });
  },
  created() {
    fetchFAQCategoryList({})
    .then(({ data }) => {
      this.categoryList = data.resultList
      this.type = this.categoryList[0].category
    })
    .then(() => {
      fetchFAQList({
        pageIndex: this.pageIndex,
        recordCntOnPage: 20,
        searchType: this.type
      })
      .then(({ data }) => {
        this.faqList = data.resultList
        this.listCnt = data.resultCnt
        this.startRender = true;
      })
    })
  },
  data() {
    return {
      startRender:false,
      categoryList: [],
      faqList: [],
      type: '',
      pageIndex: 1,
      listCnt: 0
    }
  },
  methods: {
    fetchData() {
      if(this.listCnt > this.faqList.length) {
        this.pageIndex += 1;
        fetchFAQList({
          pageIndex: this.pageIndex,
          recordCntOnPage: 20,
          searchType: this.type
        })
        .then(({ data }) => {
          this.faqList = [...this.faqList, ...data.resultList]
          this.listCnt = data.resultCnt
        })
      }
    },
    toggleAnswer(e) {
       window.$(e.target).next().slideToggle('fast');
       window.$(e.target).parent().parent().siblings().children('.text').children('.a').slideUp('fast');
    },
    selectCategory(category) {
      this.pageIndex = 1;
      this.type = category;
    
      fetchFAQList({
        pageIndex: this.pageIndex,
        recordCntOnPage: 20,
        searchType: this.type
      })
      .then(({ data }) => {
        this.faqList = data.resultList
        this.listCnt = data.resultCnt
      })
    }
  },
}
</script>

<style scoped>
#more_board .post_list .text_help  img {
  width: 3.2vw;
  height: auto;
  background-size: 100%;
  top: 2.933vw;
}

.post.new .text_help > *:first-child {
  position: relative;
}
.post.new .text_help > *:first-child::before {
  position: absolute !important;
  width: 6px;
  height: 6px;
  border-radius: 6px;
  background-color: var(--Red);
  left: -15px;
  top: 8px;
  content: "";
}
.post .text_help {
  padding-right: 20px;
  position: relative;
  padding-bottom: 20px;
}
.post .text_help h3 {
  font-weight: normal;
  font-size: 16px;
}
.post .text_help .con {
  font-size: 13px;
  color: var(--Gray-Mid);
}
.post .text_help .con + span {
  font-size: 12px;
  color: var(--Gray-Light);
}
.post span {
  color: #9ea3ab;
}
.post .text_help .q {
  background: url(/images/basic/icon/q.svg) no-repeat left 2px;
  padding-left: 20px;
  font-size: 14px;
}
.post .text_help .a {
  background: url(/images/basic/icon/a.svg) no-repeat left 2px;
  padding-left: 20px;
  font-size: 14px;
  color: var(--Gray-Mid);
  margin-top: 10px;
  display: none;
}

#more_board .post_list .text_help > div {
  position: relative;
}
#more_board .post_list .text_help > div.con {
  margin: 10px 0;
}
#more_board .post_list .text_help img {
  width: 3.2vw;
  height: auto;
  background-size: 100%;
  position: relative;
  top: 2.933vw;
}
#more_board #notice .post_list .text_help span {
  padding-left: 0;
}
#more_board .post_list .text_help span {
  width: 100%;
  display: inline-block;
  font-size: 0.875em;
  padding-left: 6%;
}
#more_board .post_list .text_help .q span {
  color: #252d3a;
}

</style>